import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Tooltip from "../tooltip/Tooltip";

class IconWithText extends Component {
    getIconClassName = () => {
        const {icon} = this.props;
        switch (icon){
            case "error": return "fas ms-1 fa-fw fa-exclamation-circle color-error"
            case "warning": return "fas ms-1 fa-fw fa-question-circle color-warning"
            case "info":
            default:
                return "fas ms-1 fa-fw fa-info-circle"
        }
    }
    render() {
        const {icon, text} = this.props;
        return (
            <>
                {
                    !!text &&
                    <Tooltip tooltipContent={text} type={icon !== "info" ? icon : ""}>
                        <i className={this.getIconClassName()}/>
                    </Tooltip>
                }
            </>
        );
    }
}

IconWithText.propTypes = {
    icon: PropTypes.oneOf(["error", "warning", "info"]),
    text: PropTypes.string
};

IconWithText.defaultProps = {
    icon: "info",
    text: null
};

export default IconWithText;
